(function(){
  'use strict';
  /* Producttegel: voor/achter wisselen op touch-apparaten */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-card-flip]');if(!b)return;
    e.preventDefault();
    var card=b.closest('.card');if(!card)return;
    var on=card.classList.toggle('is-flipped');
    b.setAttribute('aria-pressed',on);
    b.setAttribute('aria-label',on?'Bekijk voorkant':'Bekijk achterkant');
  });
})();
